/* Cube 3D — Mobile sticky buy bar
   Shows a fixed bar at the bottom of the mobile viewport when the main buy
   action (Add to cart, or the WhatsApp call-to-action on badge products)
   scrolls out of view. The bar stays inert while hidden so keyboard and
   screen-reader users never land on an invisible button. */
(function () {
  if (window.matchMedia('(min-width: 750px)').matches) return;

  var bar = document.getElementById('StickyAtcBar');
  if (!bar) return;

  var mainBtn = document.querySelector('product-form [type="submit"]')
    || document.querySelector('.cube-availability-cta--full');
  if (!mainBtn) return;

  var waFab = document.querySelector('.cube-whatsapp-fab');

  function setVisible(visible) {
    bar.classList.toggle('sticky-atc-bar--visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if ('inert' in bar) bar.inert = !visible;
    if (waFab) waFab.classList.toggle('cube-whatsapp-fab--lifted', visible);
  }
  setVisible(false);

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) { setVisible(!entry.isIntersecting); });
    },
    { threshold: 0 }
  );
  observer.observe(mainBtn);

  var stickyBtn = bar.querySelector('.sticky-atc-bar__btn');
  var isButton = !!stickyBtn && stickyBtn.tagName === 'BUTTON';
  if (isButton) {
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      mainBtn.click();
    });
    stickyBtn.setAttribute('aria-disabled', stickyBtn.disabled ? 'true' : 'false');
  }

  /* Sync price + button state when the variant changes.
     WhatsApp anchors update their own href (availability-whatsapp snippet). */
  var priceEl = bar.querySelector('.sticky-atc-bar__price');
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data.variant;
      if (!variant) return;

      if (priceEl) {
        var mainPrice = document.querySelector('.price--large .price-item--regular');
        if (!mainPrice) mainPrice = document.querySelector('.price--large .price-item--sale');
        if (mainPrice) priceEl.textContent = mainPrice.textContent.trim();
      }

      if (isButton) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        stickyBtn.textContent = variant.available
          ? (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'
          : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      }
    });
  }
})();
